import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { FavoriteToggle } from '../../../common/react/components/FavoriteToggle/FavoriteToggle';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { FeatureFlags } from '../../../ts/FeatureFlags';
import { CollectionTooltip } from '../Tooltips/CollectionTooltip';
import { doesTooltipNotHaveOwnerToDisplay } from '../Tooltips/Elements/Tooltip';
import { TooltipAnchor } from '../Tooltips/TooltipAnchor';
import { CardViewStyles } from './CardViewStyles';
import { ContentCard, getContentUrlForItem, ContentCardProps } from './ContentCard';
import { DetailsTooltipStyles } from './DetailsTooltipStyles';
import { Thumbnail } from './Thumbnail';
import { ICollectionInfo } from '../Collections/ICollectionInfo';
import { CollectionsCardPrivateIndicator } from '../Collections/CollectionsPrivateIndicator';

export class CollectionCard extends ContentCard {


  public render() {
    const disableAutoFocus = doesTooltipNotHaveOwnerToDisplay(this.props.content);


    return (
      <div className={CardViewStyles.Card}>
        <TooltipAnchor tooltipContent={this.renderTooltipContent}
                       width={DetailsTooltipStyles.Width}
                       title={Messages.collectionDetails()}
                       disableAutoFocus={disableAutoFocus}
                       disableTooltip={this.props.disableTooltip}>
          {renderCollectionCardContent(this.props)}
        </TooltipAnchor>
        <div className={CardViewStyles.ActionRow}>
          <span className={CardViewStyles.ActionRowName} title={this.props.content.name}>
            { this.props.content.name }
          </span>
          {FeatureFlags.useCollectionsFavorites && this.showFavoritesStar() && <span>
            <FavoriteToggle isTabbable={true}
                            isFavorite={this.props.content.favorite}
                            onAddFavorite={() => this.props.addContentFavorite({ ...this.props.content, contentType: 'collection' })}
                            onRemoveFavorite={() => this.props.removeContentFavorite({ ...this.props.content, contentType: 'collection' })}/>
          </span>}
          { this.renderActionsMenu() }
        </div>
        <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>
      </div>
    );
  }

  private renderTooltipContent = () => {
    return <CollectionTooltip content={this.props.content}
                           urls={this.props.urls} />;
  }
}

// This is a separate function so other card components can reuse the collection thumbnail
export function renderCollectionCardContent(contentCardProps: ContentCardProps): JSX.Element {
  const shouldDisplayPrivateIndicator = (contentCardProps.content as ICollectionInfo).visibility === 'private';

  return (
    <div>
      <div className={CardViewStyles.CollectionCardInfoLayout}>
        <div className={contentCardProps.hoveredOrSelected ?
          CardViewStyles.CollectionCardTypeLabelAreaHovered :
          CardViewStyles.CollectionCardTypeLabelArea}>
          <span className={CardViewStyles.CollectionCardTypeLabel}>{Messages.collection()}</span>
        </div>
        <div className={CardViewStyles.CollectionCardTitleArea}>
          <div className={CardViewStyles.CollectionCardTitleText}>{contentCardProps.content.name}</div>
        </div>
        <div style={{ flexGrow: 1 }} />
        {shouldDisplayPrivateIndicator && <CollectionsCardPrivateIndicator />}
      </div>
      <Thumbnail navigateUrl={getContentUrlForItem(contentCardProps.content, contentCardProps.urls)}
        defaultImageUrl={imgPath('Blue_Gray_Gradient.png')}
        hoveredOrSelected={contentCardProps.hoveredOrSelected}
        imageCoverBackground={true}
        allowDragAndDrop={contentCardProps.allowDragAndDrop}
      />
    </div>);
}
